import PublicPageWrapper from './components/Public/PublicPageWrapper';
import Loader from './components/UI/Loader/Loader';

const BasePage = () => (
  <PublicPageWrapper
    isUser={false}
    logoClickable={false}
  >
    <Loader />
  </PublicPageWrapper>
);

export default BasePage;
